import { Injectable } from '@angular/core';
import { ReimbursementRequest } from '@models/request';
import { AdminRequestRepository } from '@repositories/admin/admin-request.repository';
import { Observable } from 'rxjs';
import { StateService } from './state.service';

@Injectable({
    providedIn: 'root',
})
export class ReimbursementRequestStateService extends StateService<ReimbursementRequest> {
    constructor(private requestRepository: AdminRequestRepository) {
        super();
    }
    public override get(id: number): Observable<ReimbursementRequest> {
        return this.requestRepository.getReimbursementRequest(id);
    }
}
